/* eslint-disable array-callback-return */
import React, { useEffect, useContext, useState } from 'react';
import Player from '../PlayerList/Player';
import './MyPlayers.css';
import CurrentUserContext from "../../Contexts/userContexts";


const MyPlayers = () => {
    const { singlePlayer, setGoalkeeper, setDefender, setMidfielder, setForward } = useContext(CurrentUserContext);
    const [myPlayer, setMyPlayer] = useState([]);

    let myPlayersArray = []

    let values = []

    function allStorage() {
        let keys = Object.keys(localStorage),
            i = keys.length;

        while (i--) {
            values.push(keys[i]);
        }
        getNewPlayer(values)
    }

    const onClickClear = () => {
        localStorage.clear();
        setGoalkeeper([]);
        setDefender([]);
        setMidfielder([]);
        setForward([]);
    }

    function getNewPlayer(values) {
        singlePlayer.map(
            el => (
                values.map(valId => {
                    if (el.player[0].idPlayer === valId) {
                        (myPlayersArray.push(el.player[0]))
                    }
                })
            )
        )
        setMyPlayer(myPlayersArray)

    }

    //console.log(myPlayer)


    useEffect(() => {
        allStorage()
    })

    return (
        <div>
            <div className="myPlayers">
                {myPlayer.map(el => <Player {...el} />)}
            </div>
            <div className='button'>
                <button onClick={onClickClear} className="clearPlayers">
                    Delete Players
                </button>
            </div>
        </div>


    )

}

export default MyPlayers;